/* eslint-disable import/prefer-default-export */
export const APP_REDUX_ROOT_KEY = 'FileDiff';
